// src/contexts/TasksContext.js
import React, { createContext, useState, useContext } from 'react';

const TasksContext = createContext();

export const TasksProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refreshTasks = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <TasksContext.Provider value={{ refreshTrigger, refreshTasks }}>
      {children}
    </TasksContext.Provider>
  );
};

export const useTasksContext = () => {
  const context = useContext(TasksContext);
  if (context === undefined) {
    // En lugar de lanzar un error, proporcionar un valor predeterminado
    return { refreshTrigger: 0, refreshTasks: () => {} };
  }
  return context;
};